import { METRIC_TYPES, RESIDUAL_RETURN } from "helpers/metrics/constants"

export const SUMMARY_PERFORMANCE_RETURN_IDS = [
  "totalReturn",
  "specificReturn",
  "factorsReturn",
  "tradingReturn",
  RESIDUAL_RETURN,
]

export const SUMMARY_RISK_DECOMPOSITION_IDS = [
  "totalDecompRisk",
  "specificDecompRisk",
  "factorsDecompRisk",
]

export function getSummaryPerformanceMetricDisplayId(selectedMetricDisplay: string) {
  return selectedMetricDisplay === METRIC_TYPES.CUMULATIVE_PERCENT
    ? METRIC_TYPES.CUMULATIVE_PERCENT
    : "cumulativeCurrency"
}

export function getPerformanceSummaryRowMetricIds(
  flattenedMetrics: Record<string, unknown>,
  selectedMetricDisplay: string,
) {
  const performanceDisplayId = getSummaryPerformanceMetricDisplayId(selectedMetricDisplay)

  return SUMMARY_PERFORMANCE_RETURN_IDS
    .map((metricId) => `performance.summary.${metricId}.${performanceDisplayId}`)
    .filter((metricId) => flattenedMetrics[metricId])
}

export function getRiskSummaryRowMetricIds(flattenedMetrics: Record<string, unknown>) {
  return SUMMARY_RISK_DECOMPOSITION_IDS
    .map((metricId) => `risk.summary.${metricId}.value`)
    .filter((metricId) => flattenedMetrics[metricId])
}
